// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MmA_","productName":"Table_productName__3oKS0"};